import script from "./Commodity.vue?vue&type=script&setup=true&lang=js"
export * from "./Commodity.vue?vue&type=script&setup=true&lang=js"

import "./Commodity.vue?vue&type=style&index=0&id=c11ca674&lang=css"

const __exports__ = script;

export default __exports__